module.exports = __webpack_public_path__ + "static/media/wreath.89ba4f9f.png";